import React, { useEffect } from "react";
import ChangePageTitle from "../components/change-title-page";
import Profile_content from "../components/component-profile";
import { useUserStore } from "../store/useUserStore";
import { useNavigate } from "react-router-dom";

function Profile() {

    const user = useUserStore((state) => state.user);
    
    const navigate = useNavigate();
    useEffect(()=>{
        if(!user.auth){
            navigate('/');
        }
    },[]);

    return (
        <>
            <ChangePageTitle pageTitle="پروفایل | رستوران باغبان"/>
            <Profile_content />
        </>

    );

}

export default Profile;